export default({
    set_headers(state,payload){
        state.headers = payload
    },
    set_data(state,payload){
        state.data = payload
    },
    set_loading(state,status) {
        state.loading = status
    },
    clear_table(state){
        state.headers = [],
        state.data = []
    },
    action_for(state,action){
        state.action_for = action
    },
    set_default_password(state,password){
        state.users.default_password = password
    },
    set_default_office(state,office){
        state.users.office = office
    },
    set_user_data_with_roles(state,data){
        state.users.data = data
    },
    set_office_data (state,data){
        state.offices.data = data
    },
    set_office_group(state,office_group){
        state.offices.office_group = office_group
    }
})